export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  description: string;
  status: string;
  updateTime: string;
  views: number;
  chapters: Chapter[];
  tags: string[];
}

export interface Chapter {
  id: number;
  title: string;
  updateTime: string;
  images: string[];
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "星光下的约定",
    author: "金秀雅",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20couple%20under%20starry%20night%20sky%2C%20soft%20watercolor%20illustration%2C%20warm%20pink%20and%20gold%20tones%2C%20dreamy%20atmosphere%2C%20beautiful%20character%20design%2C%20clean%20simple%20background%2C%20emotional%20expression%2C%20delicate%20lineart%2C%20pastel%20color%20palette&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    category: "romance",
    rating: 4.8,
    description: "在首尔的星空下，两个来自不同世界的人相遇了。一个是冷酷的财阀继承人，一个是怀揣梦想的平凡女孩。命运的齿轮开始转动，他们的故事将如何展开？这部作品以其细腻的情感刻画和精美画风，成为韩国最受欢迎的爱情漫画之一。",
    status: "连载中",
    updateTime: "2026-08-04",
    views: 1285000,
    tags: ["纯爱", "都市", "治愈"],
    chapters: [
      { id: 1, title: "第1话 命运般的相遇", updateTime: "2026-07-01", images: [] },
      { id: 2, title: "第2话 意外的重逢", updateTime: "2026-07-08", images: [] },
      { id: 3, title: "第3话 心跳加速", updateTime: "2026-07-15", images: [] },
      { id: 4, title: "第4话 无法抗拒的吸引", updateTime: "2026-07-22", images: [] },
      { id: 5, title: "第5话 心动的信号", updateTime: "2026-07-29", images: [] },
      { id: 6, title: "第6话 靠近的心", updateTime: "2026-08-04", images: [] },
    ],
  },
  {
    id: 2,
    title: "剑与魔法之王国",
    author: "李在勋",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20warrior%20with%20sword%20in%20magical%20kingdom%2C%20epic%20adventure%20illustration%2C%20golden%20and%20emerald%20color%20scheme%2C%20dynamic%20action%20pose%2C%20detailed%20armor%20design%2C%20clean%20simple%20background%2C%20digital%20art%20style%2C%20dramatic%20lighting&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    category: "fantasy",
    rating: 4.9,
    description: "在一个魔法与剑共存的世界，年轻的骑士艾德踏上了拯救王国的旅程。他必须集齐七颗魔法宝石，打败黑暗领主。华丽的战斗场面、庞大的世界观、深刻的人物刻画，让这部作品成为奇幻漫画的标杆之作。",
    status: "连载中",
    updateTime: "2026-08-03",
    views: 2150000,
    tags: ["冒险", "魔法", "热血"],
    chapters: [
      { id: 1, title: "第1话 启程之日", updateTime: "2026-06-10", images: [] },
      { id: 2, title: "第2话 第一个试炼", updateTime: "2026-06-17", images: [] },
      { id: 3, title: "第3话 魔龙之谷", updateTime: "2026-06-24", images: [] },
      { id: 4, title: "第4话 光之宝石", updateTime: "2026-07-01", images: [] },
      { id: 5, title: "第5话 暗影来袭", updateTime: "2026-07-08", images: [] },
    ],
  },
  {
    id: 3,
    title: "都市猎人",
    author: "朴志浩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20modern%20city%20hunter%20in%20leather%20jacket%20on%20rooftop%20at%20night%2C%20noir%20style%20illustration%2C%20dark%20red%20and%20charcoal%20tones%2C%20mysterious%20atmosphere%2C%20cool%20character%20design%2C%20city%20lights%20background%2C%20sharp%20lineart%2C%20cinematic%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    category: "action",
    rating: 4.7,
    description: "白天是普通的上班族，夜晚化身正义的都市猎人。金志勋在双重身份中游走，打击城市中的黑暗势力。紧张刺激的追逐战、精彩绝伦的打斗场面，每一页都让人血脉喷张。年度最火爆的动作漫画，千万不可错过！",
    status: "已完结",
    updateTime: "2026-07-15",
    views: 3890000,
    tags: ["都市", "战斗", "正义"],
    chapters: [
      { id: 1, title: "第1话 夜幕降临", updateTime: "2026-01-01", images: [] },
      { id: 2, title: "第2话 猎人之眼", updateTime: "2026-01-08", images: [] },
      { id: 3, title: "第3话 追踪", updateTime: "2026-01-15", images: [] },
      { id: 4, title: "第4话 对决", updateTime: "2026-01-22", images: [] },
    ],
  },
  {
    id: 4,
    title: "第九区谜案",
    author: "崔恩智",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20detective%20in%20dim%20alley%20with%20magnifying%20glass%2C%20noir%20illustration%2C%20dark%20teal%20and%20shadow%20tones%2C%20suspenseful%20atmosphere%2C%20intricate%20details%2C%20clean%20simple%20composition%2C%20mysterious%20mood%2C%20sharp%20shadows&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    category: "thriller",
    rating: 4.6,
    description: "第九区接连发生离奇失踪案件，新人刑警韩素拉深入调查，发现背后隐藏着一个惊人的秘密。层层反转的剧情、缜密的推理过程、细腻的人物心理描写，带你走进悬疑的世界。每一个细节都可能是关键线索！",
    status: "连载中",
    updateTime: "2026-08-02",
    views: 950000,
    tags: ["推理", "犯罪", "心理"],
    chapters: [
      { id: 1, title: "第1话 失踪者", updateTime: "2026-05-01", images: [] },
      { id: 2, title: "第2话 线索", updateTime: "2026-05-08", images: [] },
      { id: 3, title: "第3话 迷雾重重", updateTime: "2026-05-15", images: [] },
    ],
  },
  {
    id: 5,
    title: "社长大人请自重",
    author: "尹智秀",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20comedy%20office%20couple%20flirting%2C%20cute%20chibi%20style%20illustration%2C%20pink%20and%20mint%20color%20scheme%2C%20playful%20expressions%2C%20clean%20simple%20background%2C%20sweet%20romantic%20vibe%2C%20cartoonish%20comedy%20style%2C%20light%20hearted%20atmosphere&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    category: "comedy",
    rating: 4.5,
    description: "刚入职的小职员竟然和公司社长成为了邻居？每天早上一开门就是社长那张帅脸，上班还要面对他的各种刁难。这部轻松搞笑的办公室恋爱喜剧，绝对能让你笑出腹肌！甜蜜又爆笑，堪称解压神器。",
    status: "连载中",
    updateTime: "2026-08-04",
    views: 760000,
    tags: ["办公室", "恋爱", "搞笑"],
    chapters: [
      { id: 1, title: "第1话 新邻居", updateTime: "2026-06-01", images: [] },
      { id: 2, title: "第2话 社长的秘密", updateTime: "2026-06-08", images: [] },
      { id: 3, title: "第3话 误会的开始", updateTime: "2026-06-15", images: [] },
      { id: 4, title: "第4话 心跳的距离", updateTime: "2026-06-22", images: [] },
    ],
  },
  {
    id: 6,
    title: "重生之医女无双",
    author: "韩秀晶",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20female%20doctor%20in%20Joseon%20era%20hanbok%2C%20elegant%20watercolor%20illustration%2C%20soft%20beige%20and%20rose%20tones%2C%20traditional%20Korean%20aesthetic%2C%20graceful%20character%2C%20clean%20simple%20composition%2C%20palace%20garden%20background%2C%20delicate%20brushstrokes&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    category: "historical",
    rating: 4.8,
    description: "现代女医生意外穿越到朝鲜王朝，凭借精湛医术在古代宫廷中闯出一片天地。宫廷斗争、医疗奇迹、缠绵悱恻的爱情，这部历史穿越巨作融合了宫斗、医术与爱情，让人欲罢不能！画风精美绝伦，每一帧都是壁纸级别。",
    status: "连载中",
    updateTime: "2026-08-01",
    views: 1680000,
    tags: ["穿越", "宫斗", "医术"],
    chapters: [
      { id: 1, title: "第1话 穿越之日", updateTime: "2026-04-01", images: [] },
      { id: 2, title: "第2话 宫中医女", updateTime: "2026-04-08", images: [] },
      { id: 3, title: "第3话 太子的秘密", updateTime: "2026-04-15", images: [] },
      { id: 4, title: "第4话 瘟疫来袭", updateTime: "2026-04-22", images: [] },
      { id: 5, title: "第5话 生死抉择", updateTime: "2026-04-29", images: [] },
    ],
  },
  {
    id: 7,
    title: "恐怖学园怪谈",
    author: "郑道贤",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20school%20ghost%20story%20dark%20corridor%2C%20eerie%20illustration%2C%20dark%20purple%20and%20black%20tones%2C%20spooky%20atmosphere%2C%20haunting%20character%20design%2C%20minimal%20composition%2C%20mysterious%20shadow%20figure%2C%20clean%20lineart&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    category: "horror",
    rating: 4.4,
    description: "转学到这所古老的学校后，奇怪的灵异事件接连发生。午夜走廊的脚步声、镜子里不属于自己的倒影、图书馆深处的低语……每集一个恐怖故事，胆小者慎入！细思极恐的剧情设计，让你看完不敢关灯睡觉。",
    status: "已完结",
    updateTime: "2026-06-30",
    views: 1420000,
    tags: ["校园", "灵异", "惊悚"],
    chapters: [
      { id: 1, title: "第1话 转校生", updateTime: "2026-01-01", images: [] },
      { id: 2, title: "第2话 镜中之人", updateTime: "2026-01-08", images: [] },
      { id: 3, title: "第3话 图书馆的第十三排", updateTime: "2026-01-15", images: [] },
    ],
  },
  {
    id: 8,
    title: "猫咪咖啡厅",
    author: "姜美莱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cute%20cat%20cafe%20barista%20girl%20with%20cats%2C%20cozy%20warm%20illustration%2C%20cream%20and%20orange%20tones%2C%20peaceful%20atmosphere%2C%20kawaii%20chibi%20style%2C%20clean%20simple%20composition%2C%20soft%20lighting%2C%20heartwarming%20mood&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    category: "daily",
    rating: 4.6,
    description: "在一家安静的小巷里，有一间充满猫咪的咖啡厅。店主小美和她的猫咪朋友们，每天迎接不同的客人，聆听不同的故事。温暖治愈的日常漫画，配合软萌的猫猫插画，是缓解压力、治愈心灵的最佳选择。",
    status: "连载中",
    updateTime: "2026-08-03",
    views: 520000,
    tags: ["治愈", "猫", "日常"],
    chapters: [
      { id: 1, title: "第1话 咖啡与猫", updateTime: "2026-03-01", images: [] },
      { id: 2, title: "第2话 第一位客人", updateTime: "2026-03-08", images: [] },
      { id: 3, title: "第3话 雨天的温暖", updateTime: "2026-03-15", images: [] },
    ],
  },
  {
    id: 9,
    title: "秘密花园之恋",
    author: "金秀雅",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20couple%20in%20beautiful%20garden%20with%20flowers%2C%20elegant%20illustration%2C%20soft%20pastel%20pink%20and%20green%20tones%2C%20romantic%20mood%2C%20detailed%20floral%20background%2C%20beautiful%20characters%2C%20dreamy%20lighting%2C%20gentle%20composition&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    category: "romance",
    rating: 4.7,
    description: "在一座被遗忘的秘密花园中，少女尹恩邂逅了神秘的园艺师。花开花落间，两人的感情悄然生长。但园艺师的真实身份却是一个不能说的秘密。当真相揭晓的那一刻，这份在花丛中绽放的爱情能否经受住考验？",
    status: "连载中",
    updateTime: "2026-08-02",
    views: 890000,
    tags: ["纯爱", "神秘", "唯美"],
    chapters: [
      { id: 1, title: "第1话 被遗忘的花园", updateTime: "2026-05-01", images: [] },
      { id: 2, title: "第2话 花与少年", updateTime: "2026-05-08", images: [] },
      { id: 3, title: "第3话 秘密的芬芳", updateTime: "2026-05-15", images: [] },
    ],
  },
  {
    id: 10,
    title: "异能特工队",
    author: "李在勋",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20superpower%20team%20in%20dynamic%20pose%2C%20vibrant%20energy%20illustration%2C%20orange%20and%20teal%20color%20scheme%2C%20explosive%20action%20scene%2C%20cool%20character%20designs%2C%20clean%20simple%20composition%2C%20comic%20style%20effects%2C%20powerful%20visual%20impact&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    category: "action",
    rating: 4.5,
    description: "一群拥有特殊能力的年轻人被召集起来，组成「异能特工队」，对抗威胁世界安全的邪恶组织。每个成员都有独特的超能力，从心灵感应到时间操控。热血沸腾的团队战斗，令人拍案叫绝的能力组合，不容错过！",
    status: "连载中",
    updateTime: "2026-08-01",
    views: 1100000,
    tags: ["超能力", "团队", "战斗"],
    chapters: [
      { id: 1, title: "第1话 觉醒", updateTime: "2026-04-01", images: [] },
      { id: 2, title: "第2话 集结", updateTime: "2026-04-08", images: [] },
      { id: 3, title: "第3话 首战", updateTime: "2026-04-15", images: [] },
      { id: 4, title: "第4话 强敌", updateTime: "2026-04-22", images: [] },
    ],
  },
  {
    id: 11,
    title: "恶魔契约者",
    author: "朴志浩",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20demon%20contract%20scene%2C%20gothic%20illustration%2C%20deep%20crimson%20and%20black%20tones%2C%20intense%20dramatic%20mood%2C%20intricate%20magic%20circle%20design%2C%20clean%20simple%20composition%2C%20powerful%20visual%20presence%2C%20mysterious%20character&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    category: "fantasy",
    rating: 4.8,
    description: "少年为了拯救病危的妹妹，与恶魔签订了契约。他获得了强大的力量，但代价是自己的灵魂。在光明与黑暗之间挣扎，他能否找到打破契约的方法？黑暗奇幻风格的故事，探讨人性与欲望的深刻主题。",
    status: "连载中",
    updateTime: "2026-08-04",
    views: 1890000,
    tags: ["黑暗", "魔法", "救赎"],
    chapters: [
      { id: 1, title: "第1话 契约之夜", updateTime: "2026-06-01", images: [] },
      { id: 2, title: "第2话 力量的代价", updateTime: "2026-06-08", images: [] },
      { id: 3, title: "第3话 恶魔的低语", updateTime: "2026-06-15", images: [] },
      { id: 4, title: "第4话 第一次任务", updateTime: "2026-06-22", images: [] },
      { id: 5, title: "第5话 光明的裂缝", updateTime: "2026-06-29", images: [] },
    ],
  },
  {
    id: 12,
    title: "放学后的钢琴室",
    author: "韩秀晶",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20piano%20room%20after%20school%2C%20gentle%20slice%20of%20life%20illustration%2C%20warm%20golden%20sunlight%20tones%2C%20peaceful%20mood%2C%20two%20students%20at%20piano%2C%20clean%20simple%20composition%2C%20nostalgic%20atmosphere%2C%20soft%20color%20palette&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    category: "drama",
    rating: 4.5,
    description: "因家庭变故而沉默寡言的少女，在放学后的钢琴室里遇到了热爱音乐的少年。琴声成为他们沟通的桥梁，音符传递着无法说出口的情感。一部关于音乐、青春与成长的感人故事，细腻展现青少年内心的情感世界。",
    status: "已完结",
    updateTime: "2026-05-20",
    views: 670000,
    tags: ["校园", "音乐", "青春"],
    chapters: [
      { id: 1, title: "第1话 寂静的房间", updateTime: "2025-12-01", images: [] },
      { id: 2, title: "第2话 第一个音符", updateTime: "2025-12-08", images: [] },
      { id: 3, title: "第3话 合奏", updateTime: "2025-12-15", images: [] },
      { id: 4, title: "第4话 心声", updateTime: "2025-12-22", images: [] },
    ],
  },
];

export const banners = [
  {
    id: 1,
    title: "星光下的约定",
    subtitle: "年度最受欢迎浪漫漫画",
    description: "在首尔的星空下，命运让两个人相遇、相知、相爱",
    comicId: 1,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20couple%20under%20starry%20night%20sky%20with%20Seoul%20cityscape%20background%2C%20dreamy%20atmosphere%2C%20soft%20pink%20and%20navy%20gradient%2C%20cinematic%20composition%2C%20beautiful%20digital%20art%2C%20romantic%20mood%2C0floating%20sparkles%2C%20ethereal%20lighting%2C%20clean%20minimal%20design&width=1400&height=600&seq=banner-01&orientation=landscape",
  },
  {
    id: 2,
    title: "剑与魔法之王国",
    subtitle: "奇幻冒险巅峰之作",
    description: "踏上集齐七颗魔法宝石的史诗旅程",
    comicId: 2,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20epic%20landscape%20with%20magical%20kingdom%20castle%20and%20dragon%20silhouette%2C%20golden%20sunset%20sky%2C%20adventurous%20atmosphere%2C%20digital%20illustration%2C%20grand%20scale%2C%20warm%20amber%20and%20emerald%20tones%2C%20cinematic%20wide%20shot%2C%20clean%20composition&width=1400&height=600&seq=banner-02&orientation=landscape",
  },
  {
    id: 3,
    title: "都市猎人",
    subtitle: "人气完结巨作",
    description: "白天上班族，夜晚正义猎人，双重身份的热血冒险",
    comicId: 3,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20noir%20cityscape%20night%20scene%20with%20mysterious%20figure%20on%20rooftop%20overlooking%20neon%20city%2C%20dark%20red%20and%20charcoal%20tones%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%2C%20urban%20action%20mood%2C%20wide%20composition%2C%20modern%20digital%20art&width=1400&height=600&seq=banner-03&orientation=landscape",
  },
];

export const homepageSections = {
  hotComics: [1, 2, 3, 6, 11],
  latestUpdates: [5, 8, 9, 10, 1, 11, 4, 3],
  recommended: [7, 12, 8, 6, 2, 9],
};

export function getComicsByCategory(categorySlug: string): Comic[] {
  if (categorySlug === "all") return comics;
  return comics.filter((c) => c.category === categorySlug);
}

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics
    .filter((c) => c.category === comic.category && c.id !== comic.id)
    .slice(0, limit);
}